import { GET_TENT_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TENT_RECIPES_SUCCESS: {
      const tentRecipes = action.payload;

      if (!tentRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
